<h1>{{ duplicating ? "Duplicate Trip" : "New Trip" }}</h1>
<br />
<div id="new-trip-details" class="section dark">
  <div class="required-explainer color-red">* Required Field</div>
  <div class="fields">
    <ciao-form-field
      class="white-cell-background"
      label="Team"
      type="dropdown"
      placeholder="Select..."
      [formControlInput]="formGroup.get('userGroupId')"
      [selectOptions$]="userGroupOptions$"
      data-cy="trip-team"
    >
    </ciao-form-field>
    <ciao-form-field
      label="Start Date/Time"
      type="datetime"
      class="white-cell-background"
      [formControlInput]="formGroup.get('startDate')"
      data-cy="trip-start-date"
    ></ciao-form-field>
    <ciao-form-field
      label="Return Date/Time"
      type="datetime"
      class="white-cell-background"
      [formControlInput]="formGroup.get('endDate')"
      data-cy="trip-end-date"
    ></ciao-form-field>
  </div>
</div>
<div class="btn-group">
  <button
    class="btn-action-light"
    (click)="Cancel()"
    data-cy="cancel-trip-button"
  >
    Cancel
  </button>
  <button
    class="btn-action-solid"
    (click)="CreateTrip()"
    [disabled]="!canCreate"
    data-cy="save-trip-button"
  >
    Create Trip
  </button>
</div>
